<script setup lang="ts">
import { ArrowLeft, Plus } from 'lucide-vue-next';

defineProps<{
  activeStep: number;
}>();

defineEmits<{
  (e: 'update:activeStep', step: number): void;
}>();
</script>

<template>
  <aside class="editor-sidebar-parity dark">
    <!-- Mobile Header -->
    <div v-if="activeStep > 1" class="sidebar-header-mobile hide-desktop">
      <h2>Bet Editor</h2>
      <p>Refine your selections. Add more events.</p>
    </div>

    <!-- Desktop Header -->
    <div class="sidebar-desktop-header hide-mobile">
      <div class="sidebar-back-pill-simple dark"><ArrowLeft :size="16" /><span>Back</span></div>
      <div class="sidebar-content-stack dark">
        <h2>Bet Editor</h2>
        <p>Refine your selections. Add more events.</p>
      </div>
    </div>

    <!-- Add More Trigger -->
    <button class="sidebar-add-more-trigger dark" @click="$emit('update:activeStep', 3)">
      <div class="plus-box-parity"><Plus :size="20" /></div>
      <div class="card-text-parity">
        <span class="main-p">Add More</span>
        <span class="sub-p">Add another event</span>
      </div>
    </button>
  </aside>
</template>

<style scoped>
.editor-sidebar-parity { 
  width: 320px; 
  min-width: 320px; 
  background: #09090b; 
  padding: 40px 24px; 
  border-right: 1px solid rgba(255,255,255,0.05); 
  display: flex; 
  flex-direction: column; 
  gap: 32px; 
}
.sidebar-back-pill-simple { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; background: #18181b; border-radius: 100px; border: 1.5px solid #3f3f46; color: #fff; font-weight: 700; width: fit-content; font-size: 0.85rem; }
.sidebar-content-stack h2 { font-size: 2rem; font-weight: 900; margin-bottom: 8px; color: #fff; }
.sidebar-content-stack p { color: #71717a; font-size: 0.9rem; line-height: 1.4; }

.sidebar-add-more-trigger { 
  background: #18181b; 
  border-radius: 16px; 
  padding: 16px; 
  display: flex; 
  align-items: center; 
  gap: 16px; 
  border: 1px solid rgba(255,255,255,0.05); 
  width: 100%;
  text-align: left;
  cursor: pointer;
}
.plus-box-parity { background: #27272a; width: 44px; height: 44px; border-radius: 10px; display: flex; align-items: center; justify-content: center; color: #fff; }
.card-text-parity .main-p { display: block; font-weight: 800; color: #fff; font-size: 1rem; }
.card-text-parity .sub-p { color: #71717a; font-size: 0.75rem; }

@media (max-width: 768px) {
  .editor-sidebar-parity { 
    width: 100%; 
    min-width: 100%; 
    padding: 24px; 
    border-right: none; 
    gap: 20px;
    background: #111;
  }
  .sidebar-header-mobile { display: flex; flex-direction: column; gap: 12px; margin-bottom: 8px; }
  .sidebar-header-mobile h2 { font-size: 1.8rem; font-weight: 900; color: #fff; }
  .sidebar-header-mobile p { color: #71717a; font-size: 0.9rem; }
  .sidebar-add-more-trigger { 
    padding: 16px; 
    border-radius: 40px; 
    background: #18181b; 
    border: 1px solid rgba(255,255,255,0.1); 
  }
  .hide-mobile { display: none !important; }
}

.hide-desktop { display: none; }
@media (max-width: 1024px) {
  .hide-desktop { display: block; }
}
</style>
